export const Slip_Print = "I";
export const Slip_Email = "C";
export const Slip_Portal = "P";
export const Slip_PrintEmail = "A";
export const Slip_PrintPortal = "B";
export const Slip_PrintEmailPortal = "T";
export const Slip_EmailPortal = "D";